/**
* @file 机构名称-合规信息
* */
<template>
  <div id="organizationMessageBranch">
    <h2>{{ organizationName }}</h2>
    <div class="blueInfo">
      <p>* 如已开通监管对接服务，则本页信息必填</p>
    </div>
    <el-row type="flex" align="middle">
      <el-col :span="20">
        <div class="formTitle">平台公司机构名称信息</div>
      </el-col>
      <el-col :span="4" style="text-align: right">
        <el-button
          type="primary"
          v-show="!edit"
          @click="formEdit(true, 'form', 'edit', 'temporaryForm')"
        >
          编辑
        </el-button>
      </el-col>
    </el-row>
    <div name="form">
      <el-form
        :model="form"
        :rules="rules"
        ref="form"
        :disabled="!edit"
        label-position="left"
        label-width="200px"
      >
        <el-form-item label="负责人姓名" prop="responsibleName">
          <el-input v-model="form.responsibleName" maxlength="64"></el-input>
        </el-form-item>
        <el-form-item label="负责人电话" prop="responsiblePhone">
          <el-input v-model="form.responsiblePhone" maxlength="32"></el-input>
        </el-form-item>
        <el-form-item label="管理人姓名" prop="managerName">
          <el-input v-model="form.managerName" maxlength="64"></el-input>
        </el-form-item>
        <el-form-item label="管理人电话" prop="managerPhone">
          <el-input v-model="form.managerPhone" maxlength="32"></el-input>
        </el-form-item>
        <el-form-item label="机构名称省市区" prop="district">
          <el-cascader
            filterable
            v-model="form.district"
            :options="options"
            @change="handleChange"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="详细地址" prop="detailAddress">
          <div style="width: 100%; display: inline-block">
            <choose-address
              :value.sync="form.detailAddress"
              :disabled="!edit"
              placeholder="在地图上搜索位置"
              @clickRowFn="clickRowFn"
            ></choose-address>
          </div>
        </el-form-item>
        <el-form-item label="行政区划代码" prop="address">
          <el-input
            v-model="form.address"
            placeholder="请先选择公司所在省市区"
            :disabled="true"
          ></el-input>
        </el-form-item>
        <el-form-item label="统一社会信用代码" prop="serviceNo">
          <el-input v-model="form.serviceNo" maxlength="16"></el-input>
          <span
            class="el-form-item-remark"
            style="margin-left: 20px; position: absolute; white-space: nowrap"
            >机构名称的统一社会信用代码（税号）</span
          >
        </el-form-item>
        <el-form-item label="机构名称紧急联系电话" prop="contactPhone">
          <el-input v-model="form.contactPhone" maxlength="32"></el-input>
        </el-form-item>
        <el-form-item label="行政文书送达邮寄地址" prop="mailAddress">
          <el-input v-model="form.mailAddress" maxlength="128"></el-input>
          <span
            class="el-form-item-remark"
            style="margin-left: 20px; position: absolute; white-space: nowrap"
            >合同/文件的收货地址</span
          >
        </el-form-item>

        <el-row type="flex" align="middle" style="margin: 50px 0 20px">
          <el-col :span="22">
            <div class="formTitle">网约车平台公司经营许可</div>
          </el-col>
        </el-row>

        <el-form-item label="网络预约出租汽车经营许可证号" prop="certificate">
          <el-input v-model="form.certificate" maxlength="64"></el-input>
        </el-form-item>
        <el-form-item label="发证机构名称" prop="organization">
          <el-input v-model="form.organization" maxlength="256"></el-input>
        </el-form-item>
        <el-form-item label="初次发证日期" prop="certifyDate">
          <el-date-picker v-model="form.certifyDate" size="mini" type="date">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="有效期起" prop="startDate">
          <el-date-picker v-model="form.startDate" size="mini" type="date">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="有效期止" prop="stopDate">
          <el-date-picker v-model="form.stopDate" size="mini" type="date">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="经营区域" prop="operationArea">
          <el-input v-model="form.operationArea" maxlength="128"></el-input>
        </el-form-item>

        <el-row style="width: 733px; text-align: right; padding-bottom: 50px">
          <el-button
            v-show="edit"
            type="primary"
            @click="formSave('form')"
            :loading="loading"
          >
            保存
          </el-button>
          <el-button
            v-show="edit"
            @click="formEdit(false, 'form', 'edit', 'temporaryForm')"
            :loading="loading"
          >
            取消
          </el-button>
        </el-row>
      </el-form>
    </div>
  </div>
</template>

<script>
import provinceCitys from "../../../../public/provinceCitys";
export default {
  name: "organizationMessageBranch",
  data() {
    let startDateValidator = (rule, value, callback) => {
      let stop = Date.parse(new Date(this.form.stopDate));
      value = Date.parse(new Date(value));

      if (!value) {
        callback(new Error("生效时间不能为空"));
      } else if (stop == 0) {
        callback();
        return;
      } else if (stop <= value) {
        callback(new Error("不能大于或等于到期时间"));
      } else {
        callback();
      }
    };
    let stopDateValidator = (rule, value, callback) => {
      let start = Date.parse(new Date(this.form.startDate));
      value = Date.parse(new Date(value));

      if (!value) {
        callback(new Error("到期时间不能为空"));
      } else if (start == 0) {
        callback();
        return;
      } else if (value <= start) {
        callback(new Error("不能小于或等于生效时间"));
      } else {
        callback();
      }
    };

    return {
      // 机构id
      organizationId: this.$route.query.id,
      organizationName: '',
      // 机构名称信息表单
      edit: false,
      temporaryForm: {},
      form: {},
      rules: {
        responsibleName: [{ required: true, message: "负责人姓名" }],
        responsiblePhone: [{ required: true, message: "请输入负责人电话" }],
        managerName: [{ required: true, message: "请输入管理人姓名" }],
        managerPhone: [{ required: true, message: "请输入管理人电话" }],
        detailAddress: [{ required: true, message: "请输入详细地址" }],
        district: [{ required: true, message: "请选择省市区" }],
        address: [{ required: true, message: "请选择省市区获取行政区划代码" }],
        serviceNo: [{ required: true, message: "请输入统一社会信用代码" }],
        contactPhone: [
          { required: true, message: "请输入机构名称紧急联系电话" },
        ],
        mailAddress: [
          { required: true, message: "请输入行政文书送达邮寄地址" },
        ],
        certificate: [
          { required: true, message: "请输入网络预约出租汽车经营许可证号" },
        ],
        organization: [{ required: true, message: "请输入发证机构名称" }],
        operationArea: [{ required: true, message: "请输入经营区域" }],
        certifyDate: [{ required: true, message: "请选择初次发证日期" }],
        startDate: [{ required: true, validator: startDateValidator }],
        stopDate: [{ required: true, validator: stopDateValidator }],
      },
      options: provinceCitys[0],
      // 保存按钮loading
      loading: false,
    };
  },
  async created() {
    // let digui = (list) => {
    //   list = list.map((item) => {
    //     let children = [];
    //     if (item.city && item.city.length > 0) {
    //       children = digui(item.city);
    //     }else if (item.county && item.county.length > 0) {
    //       children = digui(item.county);
    //     }
    //     return {
    //       label: item.value,
    //       value: item.code,
    //       children: children,
    //     };
    //   });
    //   return list;
    // };

    await this.getInfo();
    await this.mixinOrganizations();
    if (
      !this.organizationId &&
      this.mixinUserInfo &&
      this.mixinUserInfo.organizationType === 2
    ) {
      if (this.organizations[0].id) {
        this.organizationId = JSON.parse(
          JSON.stringify(this.organizations[0].id)
        );
        this.$set(
          this.form,
          "organizationId",
          this.organizations[0].organizationId
        );
      }
    }
  },
  methods: {
    async clickRowFn(res) {
      this.$set(this.form, "detailAddress", res.address + " " + res.name);
      this.form.longitude = res.location.lng;
      this.form.latitude = res.location.lat;
    },
    // 省市区更改
    handleChange(value) {
      if (value && value.length > 0) {
        this.$set(this.form, "district", value);
        this.$set(this.form, "address", value[value.length - 1]);
      }
    },
    // type:编辑或者取消 formName:表单form editNumber:编辑下标 temporaryForm:临时form对象
    formEdit(type, formName, editNumber, temporaryForm) {
      if (type) {
        this[temporaryForm] = JSON.parse(JSON.stringify(this[formName]));
        this[editNumber] = true;
      } else {
        this.$refs[formName].resetFields();
        this[formName] = JSON.parse(JSON.stringify(this[temporaryForm]));
        this[editNumber] = false;
      }
    },
    /**
     * 点击保存
     */
    async formSave() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.postFn();
        } else {
          this.$message.warning("请检查表单数据是否输入正确！");
        }
      });
    },
    /**
     * 接口请求-信息保存
     */
    async postFn() {
      this.loading = true;
      let url = "/api/v1/manage/organization/supervise/company";
      let params = this.$utils.deepCopyFn({
        ...this.form,
        certifyDate: Date.parse(new Date(this.form.certifyDate)),
        startDate: Date.parse(new Date(this.form.startDate)),
        stopDate: Date.parse(new Date(this.form.stopDate)),
      });
      if (params.district.length == 2) {
        // 直辖市省code
        const m = new Map([
          ["110000", "110100"], //北京
          ["120000", "120100"], //天津
          ["500000", "500100"], //重庆
          ["310000", "310100"], //上海
        ]);
        params.province = params.district[0];
        params.city = m.get(params.district[0]);
        params.district = params.district[1];
      } else if (params.district.length == 3) {
        params.province = params.district[0];
        params.city = params.district[1];
        params.district = params.district[2];
      }
      if (!params.organizationId) {
        params.organizationId = this.organizationId;
      }
      let data = await this.$axios.post(url, params);
      if (data && data.code === 1) {
        this.$message.success("保存成功！");
        this.edit = false;
        this.getInfo();
      }
      this.loading = false;
    },
    /**
     * 获取详情
     */
    async getInfo() {
      if (!this.organizationId) {
        return false;
      }
      let formURL =
        "/api/v1/manage/organization/supervise/company/" + this.organizationId;
      let data = await this.$axios.get(formURL);
      if (data && data.code === 1) {
        this.organizationName = await this.getOrgName(this.organizationId)
        if (data.data.province) {
          data.district = [
            data.data.province,
            data.data.city,
            data.data.district,
          ];
        } else {
          data.district = [data.data.city, data.data.district];
        }
        this.form = data.data || {};
        this.$refs.form.resetFields();
      }
    },
  },

  watch: {
    "form.certifyDate"(val) {
      this.form.startDate = val;
    },
  },
};
</script>

<style lang="less">
#organizationMessageBranch {
  width: 600px;
  padding-left: 40px;
  .first-level {
    display: block;
  }

  .second-level {
    padding-left: 24px;
  }
}
</style>
